import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextField } from '@mui/material'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

const PlayerIdFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  return (
    <TextField
      fullWidth
      name="playerId"
      margin="dense"
      variant="outlined"
      type="text"
      id="playerId"
      label={t('labels.playerId')}
      onChange={(e: React.ChangeEvent<{ value: string }>) => {
        handleChangeSearch('playerId', e.target.value)
      }}
      InputProps={{
        inputProps: {
          maxLength: 100,
        },
      }}
    />
  )
}
export default PlayerIdFilterType
